module.exports = __webpack_public_path__ + "static/ahbgroup.5eae14c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ahbgroup.jpg
// module id = 132
// module chunks = 153877081609448 257680017402065